import { render, staticRenderFns } from "./IconAmex.vue?vue&type=template&id=428394bd&"
import script from "./IconAmex.vue?vue&type=script&lang=ts&"
export * from "./IconAmex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports